import React, { useEffect, useState } from "react";

import { bool, func, string } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { goBack } from "react-router-redux";
import Yup from "yup";
import { actions as layoutActions } from "reducers/layout";

import Head from "pages/_components/Head";
import { resizableRoute } from "pages/_components/Resizable";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import { actions as tokenActions, selectors as tokenSelectors } from "reducers/token";
import * as i18n from "util/i18n";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";

import { Box, Text, Form, Drawer, RadioGroup, Radio, Button, BottomSheet } from "@ui-kit/components/index.es";
import Notification from "pages/_components/Notification";

function DisableBiometricToken(props) {
    DisableBiometricToken.propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        currentEmail: string.isRequired,
        mobilePhone: string.isRequired,
        fetching: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    DisableBiometricToken.defaultProps = {
        embeddedInV3Shell: false,
    };

    const { dispatch, isDesktop, isSmallDesktop, currentEmail, mobilePhone, fetching, embeddedInV3Shell } = props;

    useEffect(() => {
        dispatch(settingsActions.getUserData());
    }, []);

    useEffect(() => {
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return undefined;
        }
        dispatchV3ShellLayout(dispatch, {
            titleKey: "settings.token.disabledTokenPass.title",
            goBackPath: "/settings/token",
            rightContentMobile: null,
            scopes: ["tokenBiometricDisable"],
        });
        return () => {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        };
    }, [dispatch, embeddedInV3Shell]);

    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState("phone");

    const handleBack = () => dispatch(goBack());

    const handleSubmit = (code) => {
        dispatch(tokenActions.tokenBiometricDisabled(code));
    };

    const handleRequestCode = () => {
        dispatch(tokenActions.disableBiometricTokenPre(selectedChannel));
        setIsDrawerVisible(!isDrawerVisible);
    };

    const maskedPhone = `
    ${mobilePhone.charAt(0)}${mobilePhone.charAt(1)}******${mobilePhone.charAt(
        mobilePhone.length - 2,
    )}${mobilePhone.charAt(mobilePhone.length - 1)}`;

    const firstEmailLetter = currentEmail.charAt(0);
    const textAfterLastLetter = currentEmail.substring(currentEmail.indexOf("@") - 1, currentEmail.length);
    const maskedEmail = `${firstEmailLetter}*****${textAfterLastLetter}`;

    const isShellActive = embeddedInV3Shell && isUxDashboardImprovementsEnabled();

    return (
        <>
            {!isShellActive && <Notification scopeToShow="tokenBiometricDisable" />}
            <Box className="admin-detail-head px-0" mx={isDesktop ? 48 : null}>
                {(isDesktop || !isShellActive) && (
                    <Head
                        onBack={handleBack}
                        headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                        centerElement={
                            !isDesktop
                                ? () => (
                                      <Text as="subtitle" className="m-0 no-wrap text-white font-medium">
                                          {i18n.get("settings.token.disabledTokenPass.title")}
                                      </Text>
                                  )
                                : undefined
                        }
                        accessibilityTextId="settings.token.disabledTokenPass.title"
                    />
                )}
                {isDesktop && (
                    <Box flex my={32}>
                        <Text align="center" variant="h2">
                            {i18n.get("settings.token.disabledTokenPass.title")}
                        </Text>
                    </Box>
                )}
                <Box justify="center">
                    <Box
                        mx={24}
                        w={() => {
                            if (!isDesktop) {
                                return "100%";
                            }
                            if (isSmallDesktop) {
                                return "70%";
                            }
                            return "50%";
                        }}
                        column
                        align="center"
                        className="admin-detail-head z-index-1 px-0">
                        <Text mb={40} align="center" variant="bodyStrong">
                            {i18n.get("settings.token.disabledTokenPass.subtittle")}
                        </Text>
                        <Box my={40}>
                            <Text align="center" variant="body">
                                {i18n.get("settings.token.disabledTokenPass.info")}
                            </Text>
                            <Text align="center" variant="body">
                                {i18n.get("settings.token.disabledTokenPass.info2")}
                            </Text>
                        </Box>

                        <Form
                            buttonSubmit={{}}
                            initialValues={{}}
                            inputsList={[
                                {
                                    colProps: {
                                        size: 12,
                                    },
                                    component: "codePassField",
                                    id: "code",
                                    label: i18n.get("settings.token.disabledTokenPass.code.title"),
                                },
                            ]}
                            buttonsList={[
                                {
                                    colProps: {
                                        size: {
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                        },
                                        offset: {
                                            lg: 3,
                                        },
                                    },
                                    component: "button",
                                    key: "request",
                                    text: i18n.get("settings.token.disabledTokenPass.code.request"),
                                    variant: "outline",
                                    type: "button",
                                    onClick: () => {
                                        setIsDrawerVisible(!isDrawerVisible);
                                    },
                                    isInactive: false,
                                },
                                {
                                    colProps: {
                                        size: {
                                            xs: 12,
                                            md: 6,
                                            lg: 4,
                                        },
                                    },
                                    component: "button",
                                    key: "template",
                                    text: i18n.get("setting.token.device.security.continue"),
                                    icon: "ArrowRigth",
                                    iconVariant: "outline",
                                    type: "submit",
                                    id: "modal-button",
                                    onClick: () => {},
                                    extraInactiveCondition: () => fetching,
                                },
                            ]}
                            onSubmit={(v) => {
                                handleSubmit(v.code);
                            }}
                            rowSpacingForm={32}
                            wrapButtons
                            className="w-100"
                            validationSchema={Yup.object().shape({
                                code: Yup.string()
                                    .required(i18n.get("transfers.validation.required"))
                                    .min(14, "debe ser 12 caracteres")
                                    .max(14, "debe ser 12 caracteres"),
                            })}
                        />
                    </Box>
                </Box>
            </Box>
            <Box flex>
                {isDesktop && (
                    <Drawer
                        controlElementId="open-menu"
                        mainContentId="drawer-right-main"
                        onClose={() => {
                            setIsDrawerVisible(!isDrawerVisible);
                        }}
                        placement="right"
                        isVisible={isDrawerVisible}
                        title={i18n.get("settings.token.disabledTokenPass.code.request")}>
                        <Box my={40}>
                            <Text>{i18n.get("settings.token.disabledTokenPass.drawer.text1")}</Text>
                        </Box>
                        <RadioGroup value={selectedChannel} onChange={({ target }) => setSelectedChannel(target.value)}>
                            <Radio
                                id="phone"
                                value="phone"
                                label={`${i18n.get("settings.token.disabledTokenPass.drawer.sms")} ${maskedPhone}`}
                            />
                            <Radio
                                id="email"
                                value="email"
                                label={`${i18n.get("settings.token.disabledTokenPass.drawer.mail")} ${maskedEmail}`}
                            />
                        </RadioGroup>
                        <Box my={40}>
                            <Button
                                w="100%"
                                icon="ArrowRight"
                                iconVariant="outline"
                                text="Enviar"
                                onClick={() => handleRequestCode()}
                            />
                        </Box>
                    </Drawer>
                )}
                {!isDesktop && (
                    <BottomSheet
                        title={i18n.get("settings.token.disabledTokenPass.code.request")}
                        className="px-4"
                        onClose={() => {
                            setIsDrawerVisible(!isDrawerVisible);
                        }}
                        isVisible={isDrawerVisible}>
                        <Box my={40}>
                            <Text>{i18n.get("settings.token.disabledTokenPass.drawer.text1")}</Text>
                        </Box>
                        <RadioGroup value={selectedChannel} onChange={({ target }) => setSelectedChannel(target.value)}>
                            <Radio
                                id="phone"
                                value="phone"
                                label={`${i18n.get("settings.token.disabledTokenPass.drawer.sms")} ${maskedPhone}`}
                            />
                            <Radio
                                id="email"
                                value="email"
                                label={`${i18n.get("settings.token.disabledTokenPass.drawer.mail")} ${maskedEmail}`}
                            />
                        </RadioGroup>
                        <Box my={40}>
                            <Button
                                w="100%"
                                icon="ArrowRight"
                                iconVariant="outline"
                                text="Enviar"
                                onClick={() => handleRequestCode()}
                            />
                        </Box>
                    </BottomSheet>
                )}
            </Box>
        </>
    );
}

const mapStateToProps = (state) => ({
    inviteCode: tokenSelectors.getInviteCode(state),
    tokenBiometricValid: tokenSelectors.getTokenBiometricValid(state),
    currentEmail: settingsSelectors.getEmail(state),
    mobilePhone: settingsSelectors.getMobilePhone(state) || "",
    fetching: tokenSelectors.getFetching(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(DisableBiometricToken);
